import VideoDemo from '@/pages/home/components/VideoDemo';
import EmulsionDemo from '@/pages/home/components/EmulsionDemo';
import Laboratorio from '@/pages/home/components/Laboratorio';
import Services from '@/pages/home/components/Services';

export default function Servicios() {
  return (
    <main className="min-h-screen bg-background-50">
      <VideoDemo />
      <EmulsionDemo />
      <Laboratorio />
      <Services />
    </main>
  );
}